(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery-deferred-load"] && !Shopify.designMode) return;
  try {
    (function () {
  var DESKTOP_MQ = window.matchMedia('(min-width: 980px)');
  var FLICKITY_POLL_MS = 50;
  var FLICKITY_MAX_ATTEMPTS = 80;
  var boundGalleries = new WeakSet();

  function stashImage(img) {
    if (!img || img.dataset.galleryStash === 'done' || img.dataset.galleryStash === 'pending') return;
    img.dataset.galleryStash = 'pending';
    if (img.getAttribute('src')) {
      img.dataset.gallerySrc = img.getAttribute('src');
      img.removeAttribute('src');
    }
    if (img.getAttribute('srcset')) {
      img.dataset.gallerySrcset = img.getAttribute('srcset');
      img.removeAttribute('srcset');
    }
  }

  function restoreImage(img) {
    if (!img) return;
    if (img.dataset.galleryStash === 'pending' || img.dataset.gallerySrc) {
      if (img.dataset.gallerySrc) img.setAttribute('src', img.dataset.gallerySrc);
      if (img.dataset.gallerySrcset) img.setAttribute('srcset', img.dataset.gallerySrcset);
      img.dataset.galleryStash = 'done';
    }
  }

  function restoreCell(cell) {
    if (!cell) return;
    restoreImage(cell.querySelector('.product__image'));
  }

  function restoreAllGalleryImages(gallery) {
    if (!gallery) return;
    gallery.querySelectorAll('.product__image').forEach(restoreImage);
  }

  function isScrollGalleryDesktop(gallery) {
    return gallery.hasAttribute('data-scroll-gallery') && DESKTOP_MQ.matches;
  }

  function shouldDeferGallery(gallery) {
    if (isScrollGalleryDesktop(gallery)) return false;
    try {
      var config = JSON.parse(gallery.dataset.galleryConfig || '{}');
      if (config.mainSlider === false) return false;
    } catch (e) {}
    return true;
  }

  function attachFlickityDeferred(main, gallery) {
    if (typeof Flickity === 'undefined') return false;

    var flkty = Flickity.data(main);
    if (!flkty) return false;

    if (boundGalleries.has(gallery)) return true;
    boundGalleries.add(gallery);

    var cells = main.querySelectorAll('.carousel-cell');
    cells.forEach(function (cell, index) {
      if (index === 0) {
        restoreCell(cell);
        return;
      }
      stashImage(cell.querySelector('.product__image'));
    });

    restoreCell(flkty.cells[flkty.selectedIndex] && flkty.cells[flkty.selectedIndex].element);
    var adjacentCell = flkty.cells[flkty.selectedIndex + 1];
    if (adjacentCell) restoreCell(adjacentCell.element);

    flkty.on('select', function (index) {
      restoreCell(flkty.cells[index] && flkty.cells[index].element);
      var nextCell = flkty.cells[index + 1];
      if (nextCell) restoreCell(nextCell.element);
    });

    return true;
  }

  function waitForFlickity(main, gallery, attempts) {
    if (!main || !gallery) return;

    if (attachFlickityDeferred(main, gallery)) return;

    if (attempts >= FLICKITY_MAX_ATTEMPTS) {
      restoreAllGalleryImages(gallery);
      return;
    }

    setTimeout(function () {
      waitForFlickity(main, gallery, attempts + 1);
    }, FLICKITY_POLL_MS);
  }

  function initDeferredGallery(root) {
    var gallery = (root || document).querySelector('.js-product-gallery');
    if (!gallery) return;

    if (!shouldDeferGallery(gallery)) {
      restoreAllGalleryImages(gallery);
      return;
    }

    var main = gallery.querySelector('.js-carousel-main');
    if (!main) return;

    waitForFlickity(main, gallery, 0);
  }

  function bindScrollGalleryResize(gallery) {
    if (!gallery || !gallery.hasAttribute('data-scroll-gallery') || gallery.dataset.galleryResizeBound) return;
    gallery.dataset.galleryResizeBound = '1';

    DESKTOP_MQ.addEventListener('change', function () {
      if (DESKTOP_MQ.matches) {
        restoreAllGalleryImages(gallery);
        boundGalleries.delete(gallery);
        return;
      }
      var main = gallery.querySelector('.js-carousel-main');
      if (main) waitForFlickity(main, gallery, 0);
    });
  }

  function setup(root) {
    var gallery = (root || document).querySelector('.js-product-gallery');
    if (!gallery) return;
    bindScrollGalleryResize(gallery);
    initDeferredGallery(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setup(); });
  } else {
    setup();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target.querySelector('.js-product-gallery')) {
      setup(event.target);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
